import React from 'react';
import { isBrowser } from 'react-device-detect';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import LuckyDaysLogo from '@/components/UI/Logos/LuckyDaysLogo';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import { Button } from '@/components/buttons/Button';
import { DrawerName } from '@/store/ui/reducers';
import { openDrawer } from '@/store/ui/actions';
import { BaseModalProps, MODALS } from '@/features/modal/types';
import { useModal } from '@/features/modal/useModal';

export const FailedLoginModal = ({ closeModal }: BaseModalProps) => {
  const dispatch = useDispatch();
  const navigate = useAbsoluteNavigate();
  const intl = useIntl();
  const { openModal, resetModals } = useModal();

  function helpClickHandler() {
    closeModal();

    if (isBrowser) {
      setTimeout(() => {
        dispatch(openDrawer(DrawerName.Help));
      }, 200);
    } else {
      navigate('/help');
    }
  }

  const onForgotPasswordClicked = () => {
    resetModals();
    navigate('/forgot-password');
  };

  const onLoginAgainClicked = () => {
    openModal(MODALS.LOGIN);
  };

  return (
    <ModalLayout close={closeModal}>
      <div className="grid grid-cols-1 gap-6 justify-items-center">
        <LuckyDaysLogo />
        <div className="text-center">{intl.formatMessage({ id: 'failedLogin.text' })}</div>
        <div className="grid grid-cols-1 gap-4 justify-self-stretch">
          <Button
            type="button"
            onClickHandler={onForgotPasswordClicked}
            text={intl.formatMessage({ id: 'failedLogin.text.resetPassword' })}
          />
          <Button
            type="button"
            onClickHandler={helpClickHandler}
            text={intl.formatMessage({ id: 'failedLogin.text.contactSupport' })}
          />
          <Button
            type="button"
            onClickHandler={onLoginAgainClicked}
            text={intl.formatMessage({ id: 'failedLogin.text.tryAgain' })}
          />
        </div>
      </div>
    </ModalLayout>
  );
};
